import React from "react";
import {Alert, Button, IconButton, Portal, Snackbar} from "@mui/material";
import {CloseOutlined as Close} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {notificationIdentity, useNotifications} from "./notification-context";
import {notificationText} from "./notification-presentation";

export default function NotificationFeedback() {
    const center = useNotifications(), {t} = useTranslation();
    const incomingId = center.incoming ? notificationIdentity(center.incoming) : null;
    const dismissIncoming = () => center.dismissIncoming(incomingId);
    // Keep actions within the active panel's focus trap; fall back to the document outside it.
    return <Portal container={center.feedbackContainer}>
        <Snackbar open={Boolean(center.feedback)} anchorOrigin={{vertical: "bottom", horizontal: "center"}}>
            <Alert severity="warning" onClose={center.dismissFeedback}
                action={<><Button color="inherit" disabled={center.markingAll || center.pendingIds.size > 0}
                    onClick={center.feedback?.retry}>{t("Retry")}</Button>
                    <IconButton size="small" color="inherit" aria-label={t("Close")} onClick={center.dismissFeedback}><Close fontSize="small"/></IconButton>
                </>}>{t(center.feedback?.message || "")}</Alert>
        </Snackbar>
        <Snackbar key={incomingId || "no-incoming"}
            open={Boolean(center.incoming) && !center.feedback} autoHideDuration={7000} disableWindowBlurListener
            onClose={(_, reason) => {if (reason !== "clickaway") {dismissIncoming();}}}
            anchorOrigin={{vertical: "bottom", horizontal: "right"}}>
            <Alert severity="info" onClose={dismissIncoming}
                action={<>{center.incoming?.orderNumber && <Button color="inherit"
                    onClick={() => center.openNotification(center.incoming)}>{t("View")}</Button>}
                    <IconButton size="small" color="inherit" aria-label={t("Close")} onClick={dismissIncoming}><Close fontSize="small"/></IconButton>
                </>}>
                {center.incoming && notificationText(center.incoming, t)}
            </Alert>
        </Snackbar>
    </Portal>;
}
